import logo from './logo.svg';
import './App.css';
import { Component, lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';

import { AppRoute } from "./AppRoute";
import { PrivateRoute } from "./PrivateRoute";
import { AdminBMRoute } from './AdminBMRoute';
import { AdminOnlyRoute } from './AdminOnlyRoute';
import { AdminApproverBMRoute } from './AdminApproverBMRoute';

import MainLayout from './Layout/MainLayout';
import { AdminLayout } from './Layout/AdminLayout';
import { PlainLayout } from './Layout/PlainLayout';
import NoLayout from './Layout/NoLayout';

const SignIn = lazy(() => 
    import('./pages/Account/SignIn').then(({SignIn}) => ({default: SignIn}))
);
const EmailVerification = lazy(() => 
    import('./pages/Account/EmailVerification').then(({EmailVerification}) => ({default: EmailVerification}))
);
const ForgotPassword = lazy(() => 
    import('./pages/Account/ForgotPassword').then(({ForgotPassword}) => ({default: ForgotPassword}))
);
const UserRegistration = lazy(() => 
    import('./pages/Account/UserRegistration').then(({UserRegistration}) => ({default: UserRegistration}))
);

const Index = lazy(() => 
    import('./pages/Index').then(({Index}) => ({default: Index}))
);
const IndexC = lazy(() => 
    import('./pages/Services/Index pages/IndexC').then(({IndexC}) => ({default: IndexC}))
);
const IndexA = lazy(() => 
    import('./pages/Services/Index pages/IndexA').then(({IndexA}) => ({default: IndexA}))
);
const IndexB = lazy(() => 
    import('./pages/Services/Index pages/IndexB').then(({IndexB}) => ({default: IndexB}))
);
const IndexD = lazy(() => 
    import('./pages/Services/Index pages/IndexD').then(({IndexD}) => ({default: IndexD}))
);

const MissionAndVision = lazy(() => 
    import('./pages/TempleInfo/MissionAndVision').then(({MissionAndVision}) => ({default: MissionAndVision}))
);
const TempleDeities = lazy(() => 
    import('./pages/TempleInfo/TempleDeities').then(({TempleDeities}) => ({default: TempleDeities}))
);
const TempleHistory = lazy(() => 
    import('./pages/TempleInfo/TempleHistory').then(({TempleHistory}) => ({default: TempleHistory}))
);
const OurPriests = lazy(() => 
    import('./pages/TempleInfo/OurPriests').then(({OurPriests}) => ({default: OurPriests}))
);
const WeekdayPoojas = lazy(() => 
    import('./pages/Services/WeekdayPoojas').then(({WeekdayPoojas}) => ({default: WeekdayPoojas}))
);
const WeeklyPriestShedules = lazy(() => 
    import('./pages/Services/WeeklyPriestShedules').then(({WeeklyPriestShedules}) => ({default: WeeklyPriestShedules}))
);
const SundaySponsor = lazy(() => 
    import('./pages/Services/SundaySponsor').then(({SundaySponsor}) => ({default: SundaySponsor}))
);
const FacilityBooking = lazy(() => 
    import('./pages/Services/FacilityBooking').then(({FacilityBooking}) => ({default: FacilityBooking}))
);
const DevoteeRegistration = lazy(() => 
    import('./pages/Activities/DevoteeRegistration').then(({DevoteeRegistration}) => ({default: DevoteeRegistration}))
);
const VolunteerSignupForm = lazy(() => 
    import('./pages/Activities/VolunteerSignupForm').then(({VolunteerSignupForm}) => ({default: VolunteerSignupForm}))
);
const DevoteesFeedbackForm = lazy(() => 
    import('./pages/Activities/DevoteesFeedbackForm').then(({DevoteesFeedbackForm}) => ({default: DevoteesFeedbackForm}))
);
const ContactUs = lazy(() => 
    import('./pages/ContactUs/ContactUs').then(({ContactUs}) => ({default: ContactUs}))
);
const BoardOfDirectors = lazy(() => 
    import('./pages/Management/BoardOfDirectors').then(({BoardOfDirectors}) => ({default: BoardOfDirectors}))
);
const BoardMinutes = lazy(() => 
    import('./pages/Management/BoardMinutes').then(({BoardMinutes}) => ({default: BoardMinutes}))
);
const Financial = lazy(() => 
    import('./pages/Management/Financial').then(({Financial}) => ({default: Financial}))
);
const TaxReceipts = lazy(() => 
    import('./pages/TaxReceipts/TaxReceipts').then(({TaxReceipts}) => ({default: TaxReceipts}))
);
const TempleServices = lazy(() => 
    import('./pages/Services/TempleServices').then(({TempleServices}) => ({default: TempleServices}))
);

const ServiceBooking = lazy(() => 
    import('./pages/Services/ServiceBooking').then(({ServiceBooking}) => ({default: ServiceBooking}))
);
const Feedback = lazy(() => 
    import('./pages/Feedback').then(({Feedback}) => ({default: Feedback}))
);
const Files = lazy(() => 
    import('./pages/Files').then(({Files}) => ({default: Files}))
);
const ImageLibrary = lazy(() => 
    import('../src/pages/ImageLibrary').then(({ImageLibrary}) => ({default: ImageLibrary}))
);
const PoojaTempleServices = lazy(() => 
    import('../src/pages/PoojaTempleServices').then(({PoojaTempleServices}) => ({default: PoojaTempleServices}))
);
const RecentBookings = lazy(() => 
    import('./pages/MyAccount/RecentBooking').then(({RecentBookings}) => ({default: RecentBookings}))
);
const ModalComponent = lazy(() => 
    import('./components/shared/ModalComponent').then(({ModalComponent}) => ({default: ModalComponent}))
);
const QuickBooking = lazy(() => 
    import('./pages/MyAccount/QuickBooking').then(({QuickBooking}) => ({default: QuickBooking}))
);
const TermsandCondtions = lazy(() => 
    import('./components/TermsandCondtions').then(({TermsandCondtions}) => ({default: TermsandCondtions}))
);
const ImageGallery = lazy(() => 
    import('../src/pages/ImageGallery').then(({ImageGallery}) => ({default: ImageGallery}))
);

const TempleTimings = lazy(() => 
    import('./pages/TempleTimings').then(({TempleTimings}) => ({default: TempleTimings}))
);
const Donation = lazy(() => 
    import('./components/Donation').then(({Donation}) => ({default: Donation}))
);
const HinduGods = lazy(() => 
    import('./components/HinduGods').then(({HinduGods}) => ({default: HinduGods}))
);
const Projects = lazy(() => 
    import('./pages/Management/Projects').then(({Projects}) => ({default: Projects}))
);
const DetailProfile = lazy(() => 
    import('./pages/MyAccount/DetailProfile').then(({DetailProfile}) => ({default: DetailProfile}))
);
const UpdatePersonalDetails = lazy(() => 
    import('./pages/MyAccount/UpdatePersonalDetails').then(({UpdatePersonalDetails}) => ({default: UpdatePersonalDetails}))
);
const Admin = lazy(() => 
    import('./pages/Admin/Admin').then(({Admin}) => ({default: Admin}))
);

const ServiceManagement = lazy(() => 
    import('./pages/Admin/ServiceManagement').then(({ServiceManagement}) => ({default: ServiceManagement}))
);
const EventManagement = lazy(() => 
    import('./pages/Admin/EventManagement').then(({EventManagement}) => ({default: EventManagement}))
);
const TempleBajan = lazy(() => 
    import('./pages/TempleInfo/TempleBajan').then(({TempleBajan}) => ({default: TempleBajan}))
);
const Bajans = lazy(() => 
    import('./components/Bajans').then(({Bajans}) => ({default: Bajans}))
);
const TempleTimeManagement = lazy(() => 
    import('./pages/Admin/TempleTimeManagement').then(({TempleTimeManagement}) => ({default: TempleTimeManagement}))
);
const TextEditor = lazy(() => 
    import('./components/shared/TextEditor').then(({TextEditor}) => ({default: TextEditor}))
);
const UpdateMissionAndVision = lazy(() => 
    import('./pages/Admin/UpdateMissionAndVision').then(({UpdateMissionAndVision}) => ({default: UpdateMissionAndVision}))
);
const EventsDetails = lazy(() => 
    import('./pages/Admin/EventsDetails').then(({EventsDetails}) => ({default: EventsDetails}))
);
const ImageGalleryAdmin = lazy(() => 
    import('./pages/Admin/ImageGalleryAdmin').then(({ImageGalleryAdmin}) => ({default: ImageGalleryAdmin}))
);
const FilesAdmin = lazy(() => 
    import('./pages/Admin/FilesAdmin').then(({FilesAdmin}) => ({default: FilesAdmin}))
);
const PriestShedule = lazy(() => 
    import('./pages/Admin/PriestShedule').then(({PriestShedule}) => ({default: PriestShedule}))
);
const PriestDetails = lazy(() => 
    import('./pages/Admin/PriestDetails').then(({PriestDetails}) => ({default: PriestDetails}))
);
const AdminHinduGods = lazy(() => 
    import('./pages/Admin/AdminHinduGods').then(({AdminHinduGods}) => ({default: AdminHinduGods}))
);
const AdminBoardMembers = lazy(() => 
    import('./pages/Admin/AdminBoardMembers').then(({AdminBoardMembers}) => ({default: AdminBoardMembers}))
);
const UpdateNews = lazy(() => 
    import('./pages/Admin/UpdateNews').then(({UpdateNews}) => ({default: UpdateNews}))
);
const UpdateSlider = lazy(() => 
    import('./pages/Admin/UpdateSlider').then(({UpdateSlider}) => ({default: UpdateSlider}))
);
const ServiceApproval = lazy(() => 
    import('./components/shared/ServiceApproval').then(({ServiceApproval}) => ({default: ServiceApproval}))
);
const MultiServiceApproval = lazy(() => 
    import('./pages/Admin/MultiServiceApproval').then(({MultiServiceApproval}) => ({default: MultiServiceApproval}))
);

const AdminAnnualSubscription = lazy(() => 
    import('./pages/Admin/AdminAnnualSubscription').then(({AdminAnnualSubscription}) => ({default: AdminAnnualSubscription}))
);
const RegionalEvents = lazy(() => 
    import('./pages/TempleInfo/RegionalEvents').then(({RegionalEvents}) => ({default: RegionalEvents}))
);
const StateRegionalEvents = lazy(() => 
    import('./components/StateRegionalEvents').then(({StateRegionalEvents}) => ({default: StateRegionalEvents}))
);
const calendar = lazy(() => 
    import('./pages/MyAccount/Calender').then(({calendar}) => ({default: calendar}))
);
const Requiredmaterials = lazy(() => 
    import('./pages/Services/Requiredmaterials').then(({Requiredmaterials}) => ({default: Requiredmaterials}))
);
const AuspiciousDates = lazy(() => 
    import('./pages/Services/AuspiciousDates').then(({AuspiciousDates}) => ({default: AuspiciousDates}))
);
const FacilityCalender = lazy(() => 
    import('./pages/Services/FacilityCalender').then(({FacilityCalender}) => ({default: FacilityCalender}))
);
const MyPendingRequest = lazy(() => 
    import('./pages/Services/MyPendingRequest').then(({MyPendingRequest}) => ({default: MyPendingRequest}))
);
const PriestCalender = lazy(() => 
    import('./pages/Services/PriestCalender').then(({PriestCalender}) => ({default: PriestCalender}))
);
const VolunteerRequirement = lazy(() => 
    import('./pages/Activities/VolunteerRequirement').then(({VolunteerRequirement}) => ({default: VolunteerRequirement}))
);
const VolunteerAcceptance = lazy(() => 
    import('./pages/Activities/VolunteerAcceptance').then(({VolunteerAcceptance}) => ({default: VolunteerAcceptance}))
);
const VolunteerAttendance = lazy(() => 
    import('./pages/Activities/VolunteerAttendance').then(({VolunteerAttendance}) => ({default: VolunteerAttendance}))
);
const TempleRequiredItems = lazy(() => 
    import('./pages/Management/TempleRequiredItems').then(({TempleRequiredItems}) => ({default: TempleRequiredItems}))
);
const AcceptedByVolunteers = lazy(() => 
    import('./pages/Activities/AcceptedByVolunteers').then(({AcceptedByVolunteers}) => ({default: AcceptedByVolunteers}))
);
const MenuAdmin = lazy(() => 
    import('./pages/Admin/MenuAdmin').then(({MenuAdmin}) => ({default: MenuAdmin}))
);
const Eventslot = lazy(() => 
    import('./pages/MyAccount/Eventslot').then(({Eventslot}) => ({default: Eventslot}))
);
const BookEventSlot = lazy(() => 
    import('./pages/MyAccount/BookEventSlot').then(({BookEventSlot}) => ({default: BookEventSlot}))
);

export default class App extends Component<any, any> {
    static displayName = App.name;

    render() {
        return (
            <Suspense fallback={<div className="loading-spinner"></div>}>
                <Switch>
                    <AppRoute layout={MainLayout} exact path="/SignIn" component={SignIn} />
                    <AppRoute layout={MainLayout} exact path="/UserRegistration" component={UserRegistration} />
                    <AppRoute layout={MainLayout} exact path="/EmailVerification" component={EmailVerification} />
                    <AppRoute layout={MainLayout} exact path="/ForgotPassword" component={ForgotPassword} />


                    {/* Temple Info */}
                    <AppRoute layout={MainLayout} exact path="/Index" component={Index} />
                    <AppRoute layout={MainLayout} exact path="/IndexC" component={IndexC} />
                    <AppRoute layout={MainLayout} exact path="/IndexA" component={IndexA} />
                    <AppRoute layout={MainLayout} exact path="/IndexB" component={IndexB} />
                    <AppRoute layout={MainLayout} exact path="/IndexD" component={IndexD} />
                    <AppRoute layout={MainLayout} exact path="/" component={Index} />
                    <AppRoute layout={MainLayout} exact path="/MissionAndVision" component={MissionAndVision} />
                    <AppRoute layout={MainLayout} exact path="/TempleDeities" component={TempleDeities} />
                    <AppRoute layout={MainLayout} exact path="/TempleHistory" component={TempleHistory} />
                    <AppRoute layout={MainLayout} exact path="/OurPriests" component={OurPriests} />
                    <AppRoute layout={MainLayout} exact path="/TempleBajan" component={TempleBajan} />

                    {/* Services */}
                    <PrivateRoute layout={MainLayout} exact path="/ServiceBooking" component={ServiceBooking} />
                    <AppRoute layout={MainLayout} exact path="/ServiceBooking/:id/:serviceTypeId" component={ServiceBooking} />
                    <AppRoute layout={MainLayout} exact path="/TempleServices" component={PoojaTempleServices} />
                    <AppRoute layout={MainLayout} exact path="/WeekdayPoojas" component={WeekdayPoojas} />
                    <AppRoute layout={MainLayout} exact path="/WeeklyPriestShedules" component={WeeklyPriestShedules} />
                    <AppRoute layout={MainLayout} exact path="/SundaySponsor" component={SundaySponsor} />
                    <AppRoute layout={MainLayout} exact path="/FacilityBooking" component={FacilityBooking} />

                    <PrivateRoute layout={MainLayout} exact path="/ServiceBooking/:recentBookedId" component={ServiceBooking} />
                    {/* Acivities             */}
                    <AppRoute layout={MainLayout} exact path="/DevoteeRegistration" component={DevoteeRegistration} />
                    <AppRoute layout={MainLayout} exact path="/VolunteerSignupForm" component={VolunteerSignupForm} />
                    <AppRoute layout={MainLayout} exact path="/DevoteesFeedbackForm" component={DevoteesFeedbackForm} />

                    {/* Contact Us */}
                    <AppRoute layout={MainLayout} exact path="/ContactUs" component={ContactUs} />

                    {/* Management */}
                    <AppRoute layout={MainLayout} exact path="/BoardOfDirectors" component={BoardOfDirectors} />
                    <AppRoute layout={MainLayout} exact path="/BoardMinutes" component={BoardMinutes} />
                    <AppRoute layout={MainLayout} exact path="/Financial" component={Financial} />
                    <AppRoute layout={MainLayout} exact path="/Projects" component={Projects} />

                    {/* Tax Receipts */}
                    <AppRoute layout={MainLayout} exact path="/TaxReceipts" component={TaxReceipts} />

                    {/* My Account */}
                    <PrivateRoute layout={MainLayout} exact path="/RecentBookings" component={RecentBookings} />
                    <PrivateRoute layout={MainLayout} exact path="/QuickBooking" component={QuickBooking} />
                    <PrivateRoute layout={MainLayout} exact path="/DetailProfile" component={DetailProfile} />
                    <PrivateRoute layout={MainLayout} exact path="/UpdatePersonalDetails" component={UpdatePersonalDetails} />

                    {/* Feedback */}
                    <AppRoute layout={MainLayout} exact path="/Feedback" component={Feedback} />
                    <AppRoute layout={MainLayout} exact path="/PoojaTempleServices" component={PoojaTempleServices} />

                    <AppRoute layout={MainLayout} exact path="/Files" component={Files} />
                    <AppRoute layout={MainLayout} exact path="/ModalComponent" component={ModalComponent} />
                    <AppRoute layout={MainLayout} exact path="/TermsandCondtions" component={TermsandCondtions} />
                    <AppRoute layout={MainLayout} exact path="/ImageLibrary" component={ImageGallery} />
                    <AppRoute layout={MainLayout} exact path="/TempleTimings" component={TempleTimings} />
                    <AppRoute layout={MainLayout} exact path="/Donation" component={Donation} />
                    <AppRoute layout={MainLayout} exact path="/HinduGods" component={HinduGods} />
                    <AppRoute layout={MainLayout} exact path="/HinduGods/:godId" component={HinduGods} />
                    <AppRoute layout={MainLayout} exact path="/TempleBajan/:BajenId" component={Bajans} />
                    <AppRoute layout={MainLayout} exact path="/RegionalEvents" component={RegionalEvents} />
                    <AppRoute layout={MainLayout} exact path="/RegionalEvents/:RegionalEventid" component={StateRegionalEvents} />

                    {/* Admin only */}

                    <AdminOnlyRoute layout={MainLayout} exact path="/PriestDetails" component={PriestDetails} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/FilesAdmin" component={FilesAdmin} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/PriestShedule" component={PriestShedule} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/AdminHinduGods" component={AdminHinduGods} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/AdminBoardMembers" component={AdminBoardMembers} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/MultiServiceApproval/" component={MultiServiceApproval} />
                    <PrivateRoute layout={MainLayout} exact path="/EventManagement/" component={EventManagement} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/TextEditor/" component={TextEditor} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/UpdateMissionAndVision/" component={UpdateMissionAndVision} />

                    {/* Admin and Board Mmebrs only */}
                    <PrivateRoute layout={AdminLayout} exact path="/Admin/" component={Admin} />
                    <AdminBMRoute layout={MainLayout} exact path="/ServiceManagement/" component={ServiceManagement} />
                    <AdminBMRoute layout={MainLayout} exact path="/EventsDetails" component={EventsDetails} />
                    <AdminBMRoute layout={MainLayout} exact path="/ImageGalleryAdmin" component={ImageGalleryAdmin} />
                    <AdminBMRoute layout={MainLayout} exact path="/UpdateNews" component={UpdateNews} />
                    <AdminBMRoute layout={MainLayout} exact path="/UpdateSlider" component={UpdateSlider} />
                    <AdminBMRoute layout={MainLayout} exact path="/AdminAnnualSubscription" component={AdminAnnualSubscription} />
                    <AdminBMRoute layout={MainLayout} exact path="/TempleTimeManagement/" component={TempleTimeManagement} />


                    {/* Admin, Approvers and Board Mmebrs only */}

                    <AdminApproverBMRoute layout={MainLayout} exact path="/VolunteerRequirement" component={VolunteerRequirement} />
                    <AdminApproverBMRoute layout={MainLayout} exact path="/VolunteerAttendance" component={VolunteerAttendance} />
                    <AdminApproverBMRoute layout={MainLayout} exact path="/TempleRequiredItems" component={TempleRequiredItems} />
                    <AdminApproverBMRoute layout={MainLayout} exact path="/MyPendingRequest" component={MyPendingRequest} />

                    <AppRoute layout={NoLayout} exact path="/ServiceApproval" component={ServiceApproval} />
                    <AppRoute layout={NoLayout} exact path="/ServiceApproval/:ServiceBookingId/:UserId/:ApproverId" component={ServiceApproval} />

                    <AppRoute layout={MainLayout} exact path="/Calendar" component={calendar} />
                    <AppRoute layout={MainLayout} exact path="/Requiredmaterials" component={Requiredmaterials} />
                    <AppRoute layout={MainLayout} exact path="/AuspiciousDates" component={AuspiciousDates} />
                    <AppRoute layout={MainLayout} exact path="/FacilityCalender" component={FacilityCalender} />
                    <AppRoute layout={MainLayout} exact path="/PriestCalender" component={PriestCalender} />
                    <PrivateRoute layout={MainLayout} exact path="/VolunteerAcceptance" component={VolunteerAcceptance} />
                    <PrivateRoute layout={MainLayout} exact path="/AcceptedServices" component={AcceptedByVolunteers} />
                    <AppRoute layout={MainLayout} exact path="/MenuAdmin" component={MenuAdmin} />
                    <AdminOnlyRoute layout={MainLayout} exact path="/Eventslot" component={Eventslot} />
                    <PrivateRoute layout={MainLayout} exact path="/BookEventSlot" component={BookEventSlot} />


                </Switch>
            </Suspense>
        );
    }
}
